import { PermissionAction } from '../../../../../../api/types/settings/permissions/permission-group-details.type';

export const ACTION_KEYS = {
  courseCapacityHoursApproval: 'course_capacity_approval',
  professorRateApproval: 'professorRateApproval',
} as const;

export const PermissionActionType = {
  [ACTION_KEYS.courseCapacityHoursApproval]: {
    label: 'אישור בקשה למכסת שעות',
    action: PermissionAction.APPROVE,
  },
  [ACTION_KEYS.professorRateApproval]: {
    label: 'אישור תעריפי הוראה',
    action: PermissionAction.APPROVE,
  },
} as const;

export const getPermissionActionKeyLabel = (actionKey: string): string => {
  const entry =
    PermissionActionType[actionKey as keyof typeof PermissionActionType];
  return entry?.label ?? actionKey;
};
